import { CompanySettings } from "@mcleod/core";
import { AutogenLayoutLMEUserMapping } from "./autogen/AutogenLayoutLMEUserMapping";

export class LMEUserMapping extends AutogenLayoutLMEUserMapping {
    override onLoad() {
        this.setPartialShipmentFieldsVisibility();
        this.setGoogleMapTypeTooltipContent();
    }

    private setPartialShipmentFieldsVisibility() {
        const companySettings = CompanySettings.get();
        const partialShipmentEnabled = companySettings.partial_shipment_enabled;
        const partialShipLicense =  companySettings.partial_shipment_licensed;
        this.textboxPartialShipmentVendor.visible = partialShipmentEnabled && partialShipLicense;
    }

    setGoogleMapTypeTooltipContent() {
        this.textboxGoogleMapDisplay.tooltipDynamicContent = () => {
            const googleMapType = this.sourceUserSettings.activeRow?.get("google_map_type");
            return googleMapType === "P" ? "Standard+ uses a combination of Standard and Satellite Maps" : null;
        }
    }
}
